module.exports = __webpack_public_path__ + "static/media/arrowright.06096833.svg";